import { useEffect } from 'react'

// Mirrors a React value into a Rails-owned hidden field. Syncing to an external
// (non-React) DOM system is a legitimate effect (REACT-089).
const useSyncHiddenField = (fieldId, value) => {
  useEffect(() => {
    const field = document.getElementById(fieldId)
    if (field && value != null) field.value = value
  }, [fieldId, value])
}

export default useSyncHiddenField
